class DetailsTabs extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback()
  }

  setupListeners() {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  handleTrigger(event) {
    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.tab === event.target.dataset.tab,
      )
    })

    this.els.panel.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.tab !== event.target.dataset.tab,
      )
    })
  }
}

if (!customElements.get('details-tabs')) {
  customElements.define('details-tabs', DetailsTabs)
}
